import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";
import "select2";
import { ImageWithDefault } from "../../../../Layout/Common/imageWithDefault";
import ReactDOM from "react-dom";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { ConvertToFloat } from "../../../../Layout/Common/common";

export const RemoveWhishList = ({ product, view = "grid", updateList }) => {
  const modalRef = useRef(null);
  const modalInstance = useRef(null);
  const [prdDetails, setPrdDetails] = useState(null);
  const { removwItemWhishList } = useGlobalFunction();

  useEffect(() => {
    if (modalRef.current) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
    }
  }, []);
  useEffect(() => {
    if (product) {
      setPrdDetails(product);
    }
  }, [product]);

  const handleShow = () => {
    modalInstance.current?.show();
  };

  const handleHide = () => {
    modalInstance.current?.hide();
  };

  const handleRemoveClick = async () => {
    var response = await removwItemWhishList("REMOVE", prdDetails.productId);
    if (response) {
      updateList();
      handleHide();
    }
  };

  return (
    <>
      {view == "grid" ? (
        <span
          className="d-flex align-items-center justify-content-center wesWishAdded wes-whishlist-active"
          data-bs-toggle="modal"
          data-bs-target="#removeFavProduct"
          onClick={handleShow}
        />
      ) : (
        <span
          className="wesWishlist wes-whishlist-active"
          data-bs-toggle="modal"
          data-bs-target="#removeFavProduct"
          onClick={handleShow}
        />
      )}
      {ReactDOM.createPortal(
        <div
          className="modal fade"
          id="addFavModal"
          tabIndex={-1}
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          ref={modalRef}
        >
          <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
            <div className="modal-content">
              <p
                className="order-status-close"
                data-bs-dismiss="modal"
                onClick={handleHide}
              >
                <i className="fa-regular fa-circle-xmark" />
              </p>
              <div className="modal-body p-0">
                <div className="product-found">
                  <div className="product-found-title">
                    <span className="wes-heart-slash" />
                    <h4>Remove Product in List</h4>
                  </div>
                  <>
                    {/* Body */}
                    <div className="product-found-body acc-shipping-update">
                      <div className="removePro-fav">
                        <h5 className="text-center fw-medium col-fs-14 lh-base">
                          Are you sure you want to remove this item from your
                          favourites?
                        </h5>
                        {prdDetails && (
                          <div className="removePro-fav-info mt-4 d-flex align-items-start">
                            <div className="removePro-img">
                              <ImageWithDefault
                                src={prdDetails.prodImage}
                                alt="product-name"
                              />
                            </div>
                            <div className="removePro-details">
                              <h6 className="col-fs-15 fs-6 fw-medium">
                                {prdDetails.description}
                              </h6>
                              <p className="col-fs-14 fw-bold m-0 fs-14">
                                $
                                {prdDetails.userPrice &&
                                  ConvertToFloat(prdDetails.userPrice)}
                              </p>
                              <small className="col-fs-13 fs-14 fw-light">
                                Code: {prdDetails.productCode}
                              </small>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="popupBtns mt-4">
                        <div className="button-effect popupBtns-two">
                          <button
                            type="submit"
                            className="btn btn-products theme-primary"
                            onClick={handleRemoveClick}
                          >
                            Yes, Remove
                          </button>
                          <button
                            type="submit"
                            className="btn btn-products btn-unavailable"
                            data-bs-dismiss="modal"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Body */}
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};
